<app-pageheader [Parent]="this">
  <add-button AddRoute="/permits/hotelreservationpermittypes/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="permits/hotelreservationpermittypes/searches"
  [AllowEdit]="true" EditUrl="/permits/hotelreservationpermittypes/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>


